import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/zh-cn/services/toxicology/monitoring-studies")({
  beforeLoad: () => { throw redirect({ href: "/zh-cn/services/regulatory-toxicology/monitoring-studies", statusCode: 301 }); },
});
